import React, { useEffect } from "react";
import { Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProfileForm from "./profile_form.tsx";

function TeamStixifyProfileAdd() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Add a New Extraction Profile | Stixify Web";
  }, []);

  return (
    <Box p={4}>
      <ProfileForm
        open
        onClose={() => navigate(-1)}
        onAddEntry={() => navigate(-1)}
        entryData={null}
      />
    </Box>
  );
}

export default TeamStixifyProfileAdd;
